/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-thrusts',['require','underscore','jquery','activities/scenario-activity','activities/activity-backblow'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  //var Backbone = require('backbone');

  //var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioActivity = require('activities/scenario-activity');
  var ActivityBackBlow = require('activities/activity-backblow');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityThrusts = ActivityBackBlow.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    doneBtn: null,
    minPressCount: 1,
    correctPressCount: 0,
    totalBlows: 0,
    totalDrops: 0,
    dropMatch: 0,
    disableAfterReachingLimit: false,
    isInfant: false,
    bvmMC: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ActivityBackBlow.prototype.initialize.apply(this, arguments);
    },

    onBeforeDestroy: function()
    {
      if (this.doneBtn)
      {
        this.doneBtn.off('click');
        this.doneBtn.addClass('disabled');
      }

      ActivityBackBlow.prototype.onBeforeDestroy.apply(this);
    },

    setupHandPositioning: function()
    {
      this.playAudio('audio', this.currentPhase);
      this.dropMatch = 0;
      this.totalDrops = 0;

      //<ContentObject id="positionHolder.panel" className="ThrustChestPositionPanel_Infant" />
      var $pObj = _.findWhere(this.currentPhase.ContentObject, {id: 'positionHolder.panel'});
      this.isInfant = $pObj.className.toLowerCase().indexOf('infant') !== -1;
      ////console.log('pos', this.isInfant);

      this.handPanel = this.currentScene.find('[data-mc=panelHolder]');//new DragPanel(this.mc.panelHolder.panel);
      _.each(this.handPanel.find('.airway-hand'), function(hand) {
        $(hand).data().origin = $(hand).position();
      });

      Draggable.create(this.handPanel.find('.airway-hand'), {
        bounds: '[data-role=scenario-activity]',
        onPress: this.onStartDrag,
        onPressParams: [this],
        onDragEnd: this.onEndDrag,
        onDragEndParams: [this],
        //force3D: false,
        type: 'top, left'
      });

      //var self = this;
      this.dropPanel = this.currentScene.find('[data-mc=drop_items]');
      this.totalDrops = this.dropPanel.find('.activity-drop').length;

      /*this.handPanel.find('.airway-hand').draggable({
        containment: '[data-role=scenario-activity]',
        cursor: 'move',
        scroll: false,
        //start: $.proxy(this.onStartDrag, this),
        revert: $.proxy(this.onIncorrectDrop, null, this),
        //revert: 'invalid'
      });

      var self = this;
      this.dropPanel = this.currentScene.find('[data-mc=drop_items]');

      _.each(this.dropPanel.find('.activity-drop'), function(dropDiv) {
        var $dropItem = $(dropDiv);
        var $validAccept = (self.currentPhase['universal']) ? '.activity-drag' : $dropItem.attr('data-mc').replace('drop', 'item');
        self.totalDrops++;

        $dropItem.droppable({
          accept: $.proxy(self.checkDropAccept, self, $validAccept, $dropItem),
          hoverClass: 'over',
          greedy: false,
          drop: $.proxy(self.onCorrectDrop, self, $dropItem)
        });
      });*/
    },

    onEndDrag: function(self)
    {
      //console.log('end', this, this.target);
      var $drag = $(this.target);
      var $cDrop = (self.currentPhase['universal']) ? self.currentScene.find('.activity-drag') : self.currentScene.find('[data-mc=' + $drag.attr('data-mc').replace('item', 'drop') + ']');

      if ($drag.data().origin && Math.abs($drag.data().origin.left - $drag.position().left) <= 150) // still in drop pen
      {
        self.revertDrag($drag);
      }
      else if ($cDrop.length > 0 && Draggable.hitTest($drag, $cDrop, '70%') && $cDrop.attr('data-mc') === 'drop' + self.dropMatch.toString()) // correct
      {
        self.onCorrectDrop.apply(self, [$cDrop, $drag]);
      }
      else // incorrect
      {
        self.onIncorrectDrop(self, $drag);
      }
      //self.onIncorrectDrop.apply($(this.target), self, true);
      //self.onIncorrectDrop($(this.target), true);
    },

    onCorrectDrop: function($dropItem, $drag)
    {
      this.dropMatch++;
      ActivityBackBlow.prototype.onCorrectDrop.apply(this, arguments);
    },

    checkDropAccept: function($valid, $drop, $drag)
    {
      //console.log('check drop', $valid, ('item' + this.dropMatch.toString()), $drag.attr('data-mc'));
      if ($drop.attr('data-mc') === 'drop' + this.dropMatch.toString() &&
          $drag.attr('data-mc') === $valid &&
          'item' + this.dropMatch.toString() === $valid)
      {
        //console.log('match');
        return true;
      }

      return false;
    },

    allComplete: function()
    {
      //console.log('check complete', this.totalDrops);
      if (this.dropMatch >= this.totalDrops || this.isInfant)
        return true;

      return false;
    },

    setupThrusts: function()
    {
      this.handMC = this.currentScene.find('[data-mc=handsHolder] [data-mc=hand]');
      //console.log('setup compressions', this.handMC);
      // setup the body and bvm states TODO

      this.playAudio('audio', this.currentPhase);
      this.currentPhase.hideCounter = (this.currentPhase.hideCounter !== undefined && (this.currentPhase.hideCounter === true || this.currentPhase.hideCounter.toLowerCase() === 'true'));
      this.currentPhase.hidePace = (this.currentPhase.hidePace !== undefined && (this.currentPhase.hidePace === true || this.currentPhase.hidePace.toLowerCase() === 'true'));

      this.counterPanel = this.currentScene.find('[data-mc=counterHolder]');
      this.showTime();
      this.totalBlows = 0;

      if (this.counterPanel.length > 0)
      {
        this.counterPanel.find('[data-mc=text_tf]').show();
        this.counterPanel.find('[data-mc=disabled_mc]').hide();
        this.counterPanel.find('[data-mc=message]').show();
        if (this.currentPhase.hideCounter === true)
        {
          //console.log('hide counter', this.currentPhase.hideCounter, typeof(this.currentPhase.hideCounter), this.currentPhase);
          this.counterPanel.find('[data-mc=text_tf]').hide();
          this.counterPanel.find('[data-mc=disabled_mc]').show();
        }
        if (this.currentPhase.hidePace)
          this.counterPanel.find('[data-mc=message]').hide();

        if (this.currentPhase.hideCounter && this.currentPhase.hidePace)
        {
          this.counterPanel.hide();//visible = false;
        }
      }

      this.attempt = 0;

      this.handMC.on('touchstart mousedown', $.proxy(this.onMouseDownHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );

      this.doneBtn = this.get('[data-mc=doneHolder] [data-mc=done]');
      this.doneBtn.addClass('disabled');
    },

    onMouseDownHandler: function($e)
    {
      $e.preventDefault();
      $e.stopImmediatePropagation();
      this.startAction();
      return false;
    },

    onMouseUpHandler: function($e)
    {
      $e.preventDefault();
      $e.stopImmediatePropagation();
      this.stopAction();
      return false;
    },

    startAction: function()
    {
      this.handMC.on('touchend mouseup mouseout', $.proxy(this.onMouseUpHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.handMC.off('touchstart mousedown');//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.handMC.removeClass('release').addClass('compress');
      if (this.currentPhase['interrupt'] && this.totalBlows >= this.currentPhase['interrupt']) // interrupt
      {
        this.finish();
        return;
      }
    },

    stopAction: function()
    {
      this.handMC.off('touchend mouseup mouseout');//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.handMC.on('touchstart mousedown', $.proxy(this.onMouseDownHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );

      //console.error('stop action');
      this.handMC.removeClass('compress').addClass('release');
      this.handMC.stop().animate({scale: 1}, {duration: 0.5});
      this.totalBlows++;

      this.showTime(this.totalBlows);
      //this.counterPanel.find('[data-mc=text_tf]').html(this.totalBlows);

      //this.mc.body.removeEventListener(Event.ENTER_FRAME, this.onEnterFrame);

      //if ((!this.disableAfterReachingLimit && this.doneBtn.hasClass('disabled')) || this.totalBlows >= 2)
      if ((!this.disableAfterReachingLimit || this.totalBreathsCount >= 2) && this.doneBtn.hasClass('disabled'))
      {
        this.doneBtn.removeClass('disabled');
        this.doneBtn.one('click', $.proxy(this.onDoneClick, this));
        if (this.disableAfterReachingLimit)
          this.disableBreathButton();
      }
    },

    onDoneClick: function()
    {
      this.doneBtn.addClass('disabled');
      this.doneBtn.off('click');
      this.handMC.off('touchstart mousedown');
      this.handMC.off('touchend mouseup mouseout');//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.evaluatePerformance();
    },

    evaluatePerformance: function()
    {
      //console.log('eval perf', this.isInfant, this.totalBlows);
      /*if (!this.isInfant)
      {
        this.finish('critical');
        return false;
      }
      else*/
      if (this.totalBlows !== 5)
      {
        this.downgradePerformance();
        this.playAudio('audio-feedback-incorrect', this.currentPhase, $.proxy(this.finalComplete, this));
      }
      else
      {
        this.playAudio('audio-feedback-correct', this.currentPhase, $.proxy(this.finalComplete, this));
      }
      //console.log('perf', this.performance);
    },

    finalComplete: function()
    {
      this.finish();
    },

    finish: function($performance)
    {
      ScenarioActivity.prototype.finish.apply(this, arguments);
    },

    showTime: function($sec)
    {
      $sec = ($sec === undefined) ? 0 : $sec;
      if (!this.counterPanel)
        return;

      this.counterPanel.find('[data-mc=text_tf]').html($sec.toString());
    }

  /*****************************************************************************************************************///}

  });

  return ActivityThrusts;

});

